<template>
  <div class="three-grids">
    <div class="header" style="margin-top: .04rem;">
      <div>{{ floorData.floorTitle }}</div>
      <a
        v-if="floorData.isMore === '0'"
        class="more"
        :href="!$isIframe ? floorData.moreUrl : 'javascript:void(0);'"
      >
        <span>更多</span>
        <img src="@/assets/img/arrow-right.png" />
      </a>
    </div>
    <div class="content">
      <template v-if="floorData.data.length > 0">
        <div v-for="(item, idx) in floorData.data" :key="idx" class="box-item">
          <a @click="$jumpToPage(item)">
            <img class="item-img" :src="item.imageUrl" />
            <span class="title">{{ item.title }}</span>
            <span class="act-price">¥ {{ item.subtitleFirst }}</span>
            <del class="sell-price">¥ {{ item.subtitleSecond }}</del>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThreeGrids',
  props: ['floorData'],
  methods: {}
}
</script>

<style lang="scss" scoped>
.three-grids {
  padding: 0 0.1rem;
  .content {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .box-item {
      width: 1.13rem;
      margin-right: 0.08rem;
      // height: 1.13rem;
      border-radius: 5px;
      a {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-bottom: 0.12rem;
        img {
          width: 100%;
          height: 1.13rem;
          border-radius: 5px;
        }
        .title {
          margin-top: 0.07rem;
          height: 0.33rem;
          line-height: 0.17rem;
          font-size: 0.12rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          word-break: break-all;
          text-align: left;
        }
        .act-price {
          margin-top: 0.07rem;
          height: 0.14rem;
          line-height: 0.14rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: 600;
          text-align: left;
          color: #e32f2f;
        }
        .sell-price {
          margin-top: 0.07rem;
          height: 0.11rem;
          line-height: 0.11rem;
          font-size: 0.11rem;
          font-family: PingFangSC, PingFangSC-Regular;
          text-align: left;
          // color: #c7c7c7;
          color: #333;
        }
      }
    }
    .box-item:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
}
</style>
